import { useRouter } from "next/router";
import { getJobs } from "../../../lib/getJobs";
import Head from "next/head";
import { Mail, Send } from "lucide-react";
import dynamic from "next/dynamic";
import Footer from "../../../components/Footer";
const Navbar = dynamic(() => import("../../../components/Navbar"), {
  ssr: false,
});
import showdown from "showdown";

const slugify = title =>
  title
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");

export default function JobDetails({ job }) {
  const router = useRouter();

  if (!job) {
    return <div className="min-h-screen flex items-center justify-center">Job not found.</div>;
  }

  const converter = new showdown.Converter();
  const html = converter.makeHtml(job.content || "");

  return (
    <>
      <Head>
        <title>{job.title} | Careers at ITMTB</title>
      </Head>
      <Navbar />

      <div className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg border shadow">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{job.title}</h1>
          <p className="text-sm text-gray-600 mb-4">
            📍 {job.location} &nbsp;|&nbsp; {job.type} &nbsp;|&nbsp; {job.experience}
          </p>

          <div className="space-y-6 text-black">
            {/* Parse sections */}
            <div className="prose md:prose-lg max-w-none" dangerouslySetInnerHTML={{ __html: html }} />

            {/* Contact Section */}
            <div className="bg-orange-50 border-t mt-8 rounded p-4">
              <h2 className="font-semibold text-gray-900 text-xl">Ready to Join Us?</h2>
              <p className="text-lg text-gray-700 mt-1">
                Send your resume to{" "}
                <a href="mailto:hello@itmtb.com" className="text-orange font-medium underline">
                  hello@itmtb.com
                </a>{" "}
                with subject: <span className="italic">Job application for {job.title}</span>
              </p>

              <div className="flex gap-3 mt-4">
                <a
                  href="mailto:hello@itmtb.com"
                  className="inline-flex items-center gap-2 px-4 py-2 border border-orange text-orange rounded hover:bg-orange hover:text-white transition text-md"
                >
                  <Mail size={16} /> Email Resume
                </a>
                {/* <button className="inline-flex items-center gap-2 px-4 py-2 bg-orange text-white rounded hover:bg-orange-600 transition">
                  <Send size={16} /> Quick Apply
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

// Static generation
export async function getStaticPaths() {
  const jobs = getJobs();
  const paths = jobs.map(job => ({
    params: { slug: slugify(job.title) },
  }));
  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const jobs = getJobs();
  const job = jobs.find(job => slugify(job.title) === params.slug) || null;
  return { props: { job } };
}
